export default "__VITE_ASSET__Bwdktfuv__"